import { render, staticRenderFns } from "./LogoPath.vue?vue&type=template&id=1ae9229c&scoped=true&"
var script = {}
import style0 from "./LogoPath.vue?vue&type=style&index=0&id=1ae9229c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae9229c",
  null
  
)

export default component.exports